<template lang='pug'>
  div
    app-header
    //- .u-relative.u-overflow-hide
      .o-wrapper.c-main-news.u-justify-center.u-pb4.u-items-center
        figure.c-main-news__image(style='background-image: url(/static/images/slide_program.jpg)')
        .u-width-100.u-mb4
          h1.c-main-news__title.u-mt4.u-mb5.u-flex-column.u-items-center
            span.u-fw-regular.u-center.u-block Conoce nuestros
            p.u-center.u-white.u-mt0.u-fw-s-bold
              | Programas periodísticos, opinión, servicios, magazine y musicales
    //- #position-scroll.c-schedule.o-wrapper
      ul.u-list-none.u-flex.u-p0.u-m0.c-schedule__wrapper
        li.u-flex-1(v-for='day in allDays')
          button.c-schedule__day(@click='changeDay(day.dayName)', :class="day.dayName === selectedDay ? 'is-active' : ''")
            | {{ day.dayName }}
      .u-list-none.u-flex.c-schedule__wrapper(v-if='allPrograms.length > 0')
        button.c-schedule__allHour(@click="changeHour('')")
          | TODOS LOS HORARIOS
        ul.u-p0.u-m0.u-flex.u-flex-1.u-flex-wrap.u-bg-tertiary
          li.u-flex-1(v-for='program in allPrograms')
            button.c-schedule__hour(@click='changeHour(program.id)', :class="idProgram === program.id ? 'is-active' : ''")
              span
                | {{ program.startTime }}
              span
                | {{ program.endTime }}
    
    div( style="background: rgb(33, 33, 120); padding: 10px;")
      h3.c-main-news__title.u-mt4.u-mb5.u-flex-column.u-items-center
            span.u-fw-regular.u-center.u-block Conoce nuestros
            p.u-center.u-white.u-mt0.u-fw-s-bold
              | Programas periodísticos, opinión, servicios, magazine y musicales

    .o-wrapper
      ul.u-flex.u-list-none.u-flex-wrap.u-m0.u-pl0
        li.u-block.c-schedule__program(v-for='ads in fifthGroup')
          p.u-color-primary.u-fw-bold.u-mt0
            | {{ads.title}}
          img( style='' class='lazyload u-12/12 c-publicity__image' :src='ads.imageUrl')

          //- p
            | De {{ program.startTime }} a {{ program.endTime }}
          //- p.u-color-text
            | {{ program.description }}
          //- p.u-color-text.u-fw-light(v-if='program.announcers')
            | Conducción: {{ program.announcers }}
          
    app-footer
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'Programs',
    data () {
      return {
        idProgram: '',
        fifthGroup: []
      }
    },

    computed: {
      ...mapGetters({
        allPrograms: 'allPrograms',
        allDays: 'allDays',
        selectedDay: 'selectedDay'
      }),

      filteredPrograms () {
        if (this.idProgram) {
          let program = this.allPrograms.find((i) => i.id === this.idProgram)
          let programs = []
          programs[0] = program
          return programs
        }

        return this.allPrograms
      }
    },

    methods: {
      ...mapActions({
        selectDay: 'selectDay'
      }),

      changeDay (day) {
        this.idProgram = ''
        this.selectDay(day)
      },

      changeHour (hour) {
        this.idProgram = hour
        this.moveDown()
      },

      moveDown () {
        window.$('body').animate({scrollTop: window.$('#position-scroll').offset().top - 10}, '1000', 'swing')
      },

      defaultDay () {
        let weekdays = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
        let dayNumber = new Date().getDay()
        let selectedDay = weekdays[dayNumber]
        this.selectDay(selectedDay)
      },

      getPublicities () {
        axios.get(`${window.API_URL}/publicities`)
          .then(({data}) => {
            this.fifthGroup = data.fifthGroup
          })
      }
    },

    mounted () {
      this.defaultDay()
      // this.filteredPrograms = this.allPrograms
    },

    created () {
      this.getPublicities()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Programs/components/ProgramsScreen.vue